import { Link } from '@ecm/router';

import { CarrouselItemButtonViewModel } from './carrousel-item-button.view-model';

export class CarrouselNavigationItemViewModel {
    public link?: Link;
    public href?: string;
    public label?: string;
    public type?: string;
    public button?: CarrouselItemButtonViewModel;
    public displayOrder?: number;
    public trackingName?: string;
    public usageCode?: string;

    public constructor(init?: CarrouselNavigationItemViewModel) {
        Object.assign(this, init);
    }
}
